export default "__VITE_ASSET__bb407920__"